<template>
  <ubi-panel>
    <ubi-list-header slot="header"
                     v-if="socialPostsAnnonces && socialPostsAnnonces.total > 0"
                     :limits="limits"
                     :total="socialPostsAnnonces.total"
                     :page.sync="page"
                     :limit.sync="limit">
    </ubi-list-header>
    <ubi-list-selection
        v-if="socialPostsAnnonces && socialPostsAnnonces.total > 0"
        slot="selection"
        :value="selectedIds"
        :current-page-ids="currentPageIds"
        @input="onListSelectionInput"
        @select="doSelect"
    />
    <template slot="actions">
      <div v-if="!selected.length">
        <el-button size="mini" v-if="isCardList" @click="setViewMode('list')"><em class="el-icon-s-fold"></em>{{ $t("users.listMode") }}</el-button>
        <el-button size="mini" v-if="isListView" @click="setViewMode('sticker')"><em class="el-icon-menu"></em>{{ $t("users.vignetteMode") }}</el-button>
      </div>
      <div v-else>
          <span>
<!--              <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) : {{ (' ') }}</span>-->
            <!--                        <el-button class="PostsList-export" size="mini" style="margin-left: 5px"-->
            <!--                                   @click="exporter(selected)">{{ $t("general.selection.export") }}</el-button>-->
              <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selectAllMode ? ((socialPostsAnnonces && socialPostsAnnonces.total) || selected.length) : selected.length }}) : {{ (' ') }}</span>
                        <el-button class="PostsList-delete" size="mini" style="margin-left: 5px"
                                   @click="deletePost(selected)">{{ $t("general.selection.remove") }}</el-button>
          </span>
      </div>
    </template>
    <ubi-list-footer
        slot="footer"
        v-if="socialPostsAnnonces.total && socialPostsAnnonces.total > 1"
        :limits="limits"
        :total="socialPostsAnnonces.total"
        :page.sync="page"
        :limit.sync="limit"
    ></ubi-list-footer>

    <!-- Sticker View => CardList-->
    <SocialPostCard
        :selected.sync="selected"
        :socialPosts="socialPostsAnnonces"
        :loading-status="loadingStatus"
        :check-nb-diffusions-actives="checkNbDiffusionsActives"
        :is-post-fully-published="isPostFullyPublished"
        :store-module="'socialNetworkPosts'"
        type="Annonces"
        @edit-post="editPost"
        @delete-post="deletePost"
        @view-post="viewPost"
    ></SocialPostCard>

    <el-table ref="table"
              v-if="socialPostsAnnonces && isListView"
              class="SocialPostsTable"
              :data="socialPostsAnnonces.list"
              v-loading="loadingStatus"
              style="width: 100%"
    >
      <el-table-column width="55" align="center">
        <template v-slot:header>
          <span></span>
        </template>
        <template v-slot="{ row: result }">
          <el-checkbox
              :value="selected.some(s => s.id === result.id)"
              @input="toggleRowSelection(result, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="Publication" min-width="320">
        <template v-slot="{ row: result }">
          <el-row>
            <el-col :lg="4">
<!--              <div v-if="possedeVideo(result) || possedeVideoUploadee(result)" style="text-align: center;">-->
<!--                <img src="Images/picto-lecteur-video.png" width="60px" />-->
<!--              </div>-->
              <div v-if="result.photoPrincipale !== false">
                <img width="60"
                     alt=""
                     :src="result.photoPrincipale.url_miniature"
                     :srcset="result.photoPrincipale.url_miniature"
                />
              </div>
              <div v-else style="text-align: center;">
                <ubi-icon class="no-photo" name="camera" size='60'/>
              </div>
            </el-col>
            <el-col :lg="18">
              <div>{{ result.reference }}<br> {{ result.titre }}</div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishOn')" min-width="100">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence-icons :post="result"></social-posts-list-table-presence-icons>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishedOn')" min-width="250">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence :post="result"></social-posts-list-table-presence>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.actions')" min-width="90" align="right">
        <template v-slot="{ row: result }">
          <div v-if="isPostFullyPublished(result)">
            <em class="el-icon-view" :title="$t('socialPosts.list.viewOnly')" @click="viewPost(result.id)"></em>
          </div>
          <div v-else>
            <em class="el-icon-edit-outline" :title="$t('posts.edit.edit')" @click="editPost(result.id)" style="margin-right: 10px;"></em>
            <em class="el-icon-delete" :title="$t('posts.edit.remove')" v-if="checkNbDiffusionsActives(result) > 0" @click="deleteModalShow(result)"></em>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </ubi-panel>
</template>

<script>

import SocialPostsListTablePresence from './SocialPostsListTablePresence'
import SocialPostsListTablePresenceIcons from './SocialPostsListTablePresenceIcons'
import { mapGetters, mapMutations, mapState } from 'vuex'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiPanel from '@/components/Panel.vue'
import UbiIcon from '@/components/Icon.vue'
import SocialPostCard from '@/components/ui/SocialPostCard.vue'
import { possedeVideo, possedeVideoUploadee } from '@/services/socialNetworkTools'
import socialPostPublicationStatus from '@/mixins/socialPostPublicationStatus'
import UbiListSelection from '@/components/lists/ListSelection.vue'

export default {
  name: 'SocialPostsTableAnnonces',
  components: {
    UbiListSelection,
    SocialPostCard,
    UbiIcon,
    UbiPanel,
    UbiListHeader,
    UbiListFooter,
    SocialPostsListTablePresence,
    SocialPostsListTablePresenceIcons
  },
  mixins: [socialPostPublicationStatus],
  data () {
    return {
      limits: [5, 10, 20],
      selected: [],
      selectAll: false,
      postsPublicationStatus: {},
      pendingMergePage: null,
      selectAllMode: false
    }
  },
  props: ['selectedPostsAnnonces'],
  watch: {
    selectedPostsAnnonces: function (val) {
      this.selected = []
      this.selectAllMode = false
    },
    'filters.page' (newPage, oldPage) {
      if (this.selectAllMode && oldPage != null && newPage !== oldPage) {
        this.pendingMergePage = newPage
      }
    },
    'socialPostsAnnonces.list': {
      async handler (list) {
        if (list && list.length > 0) {
          await this.checkPostsPublicationStatus()
        }
        if (
          this.selectAllMode &&
            this.pendingMergePage != null &&
            this.filters.page === this.pendingMergePage &&
            list &&
            list.length
        ) {
          const existingIds = new Set((this.selected || []).map(s => s.id))
          const toAdd = list.filter(item => !existingIds.has(item.id))
          this.selected = [...(this.selected || []), ...toAdd]
          this.pendingMergePage = null
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('socialPostsTableAnnonces', ['filters', 'socialPostsAnnonces', 'loadingStatus']),
    ...mapGetters('socialNetworkPosts', ['getView', 'isListView', 'isCardList']),
    ...mapGetters('postManager', ['getStatusMediaPost']),
    page: {
      get () {
        return this.filters.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
      }
    },
    limit: {
      get () {
        return this.filters.limit
      },
      set (value) {
        this.setLimit(value)
        this.setPage(1)
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
      }
    },
    currentPageIds () {
      return (this.socialPostsAnnonces.list || []).map(item => item.id)
    },
    selectedIds () {
      return (this.selected || []).map(s => s.id)
    }
  },
  mounted () {
    this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
  },
  methods: {
    possedeVideoUploadee,
    possedeVideo,
    ...mapMutations('socialPostsTableAnnonces', [
      'setPage',
      'setSocialPostsAnnonces',
      'setLimit',
      'setModalDelete'
    ]),
    setViewMode (view) {
      this.$store.commit('socialNetworkPosts/setView', view)
    },
    async checkPostsPublicationStatus () {
      if (!this.socialPostsAnnonces || !this.socialPostsAnnonces.list) return

      const statusPromises = this.socialPostsAnnonces.list.map(async post => {
        const status = await this.checkPostPublicationStatus(post.id, 'annonce')
        return { postId: post.id, ...status }
      })

      const statuses = await Promise.all(statusPromises)

      const newStatus = {}
      statuses.forEach(status => {
        newStatus[status.postId] = {
          hasRSPublished: status.hasRSPublished,
          allRSPublished: status.allRSPublished
        }
      })

      this.postsPublicationStatus = newStatus
    },
    isPostFullyPublished (post) {
      return (this.postsPublicationStatus[post.id] && this.postsPublicationStatus[post.id].allRSPublished) || false
    },
    deleteModalShow (post) {
      this.$store.commit('socialPostsTableAnnonces/setModalDelete', true)
      this.$store.commit('socialPostsTableAnnonces/setPostToDelete', [post])
    },
    deletePost (selected) {
      this.$store.commit('socialPostsTableAnnonces/setPostToDelete', selected)
      this.$store.commit('socialPostsTableAnnonces/checkDiffusionsPostsToDelete')
      this.$store.commit('socialPostsTableAnnonces/setModalDelete', true)
      this.selected = []
    },
    checkNbDiffusionsActives (post) {
      let nbEnvoyees = 0
      let found = 0

      if (post.diffusions && post.diffusions.length > 0) {
        post.diffusions.forEach(function (element) {
          if (element.firstSentAt === null) {
            nbEnvoyees = nbEnvoyees + 1
          } else {
            found = 1
          }
        })
      }
      if (found === 1) {
        nbEnvoyees = 0
      }
      if (post.diffusions.length === 0 && post.planifications) {
        nbEnvoyees = 1
      }
      if (!post.planifications) {
        nbEnvoyees = 0
      }
      return nbEnvoyees
    },
    viewPost (result) {
      if (typeof result === 'object' && result.id) {
        this.$router.push({ name: 'manage-posts', params: { id: result.id, viewOnly: true } })
      } else {
        this.$router.push({ name: 'manage-posts', params: { id: result, viewOnly: true } })
      }
    },
    editPost (result) {
      if (typeof result === 'object' && result.id) {
        this.$router.push({ name: 'manage-posts', params: { id: result.id } })
      } else {
        this.$router.push({ name: 'manage-posts', params: { id: result } })
      }
    },
    onListSelectionInput (ids) {
      if (!ids || ids.length === 0) {
        this.selected = []
        this.selectAllMode = false
      }
    },
    doSelect (type) {
      if (type === '*') {
        this.selectAllMode = true
        const list = this.socialPostsAnnonces.list || []
        const existingIds = new Set((this.selected || []).map(s => s.id))
        const toAdd = list.filter(item => !existingIds.has(item.id))
        this.selected = [...(this.selected || []), ...toAdd]
      }
      if (type === null) {
        this.selected = []
        this.selectAllMode = false
      }
    },
    toggleRowSelection (row, checked) {
      const idx = (this.selected || []).findIndex(s => s.id === row.id)
      if (checked && idx === -1) {
        this.selected = [...(this.selected || []), row]
      } else if (!checked && idx > -1) {
        this.selected = this.selected.filter(s => s.id !== row.id)
      }
    }
  }

}
</script>
<style lang="scss" scoped>
:deep(.SocialPostsTable) {
  .el-table__fixed,
  .el-table__fixed-right {
    display: none;
  }
}

em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-edit-outline:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-view {
  cursor: pointer;
  color: #606266 !important;
}
</style>
